import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush mt-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<ul class=\"\n            nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x\n            border-0\n            fs-4\n            fw-bold\n            mb-8\n          \"><li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4 active\" data-bs-toggle=\"tab\" href=\"#code_php\">PHP</a></li><li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4\" data-bs-toggle=\"tab\" href=\"#code_asp\">ASP</a></li><li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4\" data-kt-countup-tabs=\"true\" data-bs-toggle=\"tab\" href=\"#code_net\">.NET</a></li></ul>", 1)
const _hoisted_5 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "code_php",
  role: "tabpanel"
}
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "code_asp",
  role: "tabpanel"
}
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "code_net",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("ApiManual.SampleCode")), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "php")
              ]),
              _: 3
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CodeHighlighter, { lang: "javascript" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "asp")
              ]),
              _: 3
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CodeHighlighter, { lang: "aspnet" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "net")
              ]),
              _: 3
            })
          ])
        ])
      ])
    ])
  ]))
}